import { render, staticRenderFns } from "./blogDetail.vue?vue&type=template&id=6f4c3502&scoped=true"
import script from "./blogDetail.vue?vue&type=script&lang=js"
export * from "./blogDetail.vue?vue&type=script&lang=js"
import style0 from "./blogDetail.vue?vue&type=style&index=0&id=6f4c3502&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4c3502",
  null
  
)

export default component.exports